import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { var_api } from "../../../constant";

const Reports = () => {
  const itemsPerPage = 15;

  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const warehouse_id = localStorage.getItem("warehouse_id") || 1;

  // ✅ Fetch Product Master
  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  // ✅ Fetch Variant Master
  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };

  // ✅ Fetch Report Data
  const fetchReportData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${var_api}sa-veemart-inventory/getby-warehouse/${warehouse_id}`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setReportData(data);
      setFilteredData(data);
    } catch {
      toast.error("Failed to fetch report data");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Initial Load
  useEffect(() => {
    fetchProductData();
    fetchVariantData();
    fetchReportData();
  }, []);

  // ✅ Filter based on search
  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();
    const filtered = reportData.filter((item) => {
      const product = productData.find((p) => p.id === item.product_id)?.product_name || "";
      const variant = variantData.find((v) => v.id === item.variant_id)?.variant_name || "";
      return (
        product.toLowerCase().includes(lowerQuery) ||
        variant.toLowerCase().includes(lowerQuery)
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchQuery, reportData, productData, variantData]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      {/* 🔹 Full Page Loader */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div className="text-center">
            <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} />
            <div className="mt-3 fw-bold">Loading Reports...</div>
          </div>
        </div>
      )}

      <Card className="shadow-sm">
        <Card.Body>
          <h4>
           <i className="fas fa-warehouse"></i> Inventory
          </h4>

          <Row className="align-items-end mb-3">
            <Col md={3} className="ms-auto">
              <Form.Control
                type="text"
                placeholder="Search by Product or Variant..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
     {/* Table */}
<div className="table-responsive">
  <table className="table">
    <thead>
      <tr>
        <th>#</th>
        <th>Product</th>
        <th>Bill Number</th> {/* ✅ Added this line */}
        <th>Total Qty</th>
        <th>Latest Incoming</th>
        <th>Latest Outcoming</th>
      </tr>
    </thead>
    <tbody>
      {paginatedData.length === 0 ? (
        <tr>
          <td colSpan="7" className="text-center text-muted py-3">
            No data found
          </td>
        </tr>
      ) : (
        paginatedData.map((item, idx) => {
          const product =
            productData.find((p) => p.id === item.product_id)?.product_name || "-";
          const variant =
            variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";

          return (
            <tr key={item.id || idx}>
              <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
              <td>{product}</td>
              <td>{item.latest_bill_number || "-"}</td> {/* ✅ New column value */}
              <td>
                <span className="badge bg-info">{item.total_qty || 0}</span>
              </td>
              <td>
                <span className="badge bg-success">
                  {item.latest_incoming_qty || 0}
                </span>
              </td>
              <td>
                <span className="badge bg-warning">
                  {item.latest_outgoing_qty || 0}
                </span>
              </td>
            </tr>
          );
        })
      )}
    </tbody>
  </table>
</div>

        </Card.Body>
      </Card>

      <ToastContainer />
    </>
  );
};

export default Reports;
